var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"c-f-ar bt",on:{"click":_vm.cusClick}},[_vm._v(_vm._s(_vm.t || _vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }